/**
 * Bodily Bra Finder Quiz
 * File: assets/bra-quiz.js
 *
 * Handles:
 *  - Question navigation and progress
 *  - Answer state management
 *  - Recommendation logic (delegated to BQ_CONFIG.logic.recommend)
 *  - Email capture + Klaviyo list subscription
 *  - Result rendering
 *  - Analytics events (Shopify pixel + GTM ready)
 */

(function () {
  'use strict';

  // ─── Wait for DOM ────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    var app = document.getElementById('braQuizApp');
    if (!app) return;

    var cfg     = window.BQ_CONFIG;
    var answers = {};
    var currentScreen = 'intro';
    var emailCaptured = false;

    // ─── DOM refs ──────────────────────────────────────────────────────────────
    var progress  = document.getElementById('bqProgress');
    var counter   = document.getElementById('bqCounter');
    var startBtn  = document.getElementById('bqStart');
    var emailForm = document.getElementById('bqEmailForm');
    var skipBtn   = document.getElementById('bqSkipEmail');
    var restartBtn = document.getElementById('bqRestart');

    // ─── Screen management ─────────────────────────────────────────────────────
    function showScreen(name) {
      var screens = app.querySelectorAll('.bq-screen');
      screens.forEach(function (s) {
        s.classList.remove('active');
        s.setAttribute('aria-hidden', 'true');
      });
      var target = app.querySelector('[data-screen="' + name + '"]');
      if (!target) return;
      target.classList.add('active');
      target.removeAttribute('aria-hidden');
      currentScreen = name;

      // Update progress bar
      var qNum   = parseInt(target.dataset.question, 10) || 0;
      var qTotal = parseInt(target.dataset.total, 10) || 6;
      var pct    = name === 'result' ? 100 : name === 'email' ? 95 : Math.round((qNum / qTotal) * 90);
      if (progress) progress.style.width = pct + '%';
      if (counter) {
        counter.textContent = qNum > 0 ? 'Question ' + qNum + ' of ' + qTotal : '';
      }

      // Scroll to top of quiz on mobile
      var rect = app.getBoundingClientRect();
      if (rect.top < 0 || rect.top > 80) {
        app.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      // Analytics
      trackEvent('quiz_screen_view', { screen: name, answers: JSON.stringify(answers) });
    }

    // ─── Start button ──────────────────────────────────────────────────────────
    if (startBtn) {
      startBtn.addEventListener('click', function () {
        trackEvent('quiz_started', {});
        showScreen('q1');
      });
    }

    // ─── Option selection ──────────────────────────────────────────────────────
    app.addEventListener('click', function (e) {
      var opt = e.target.closest('.bq-option');
      if (!opt) return;

      var q = opt.dataset.q;
      var v = opt.dataset.v;
      if (!q || !v) return;

      // Deselect siblings
      var siblings = app.querySelectorAll('.bq-option[data-q="' + q + '"]');
      siblings.forEach(function (s) {
        s.classList.remove('selected');
        s.setAttribute('aria-checked', 'false');
      });

      // Select this one
      opt.classList.add('selected');
      opt.setAttribute('aria-checked', 'true');
      answers[q] = v;

      // Reword Q2 dynamically based on pregnancy stage
      if (q === 'stage') {
        var q2Title = document.getElementById('bqQ2Title');
        var q2Hint  = document.getElementById('bqQ2Hint');
        var yesT = document.getElementById('bqQ2OptYesTitle');
        var yesD = document.getElementById('bqQ2OptYesDesc');
        var someT = document.getElementById('bqQ2OptSomeTitle');
        var someD = document.getElementById('bqQ2OptSomeDesc');
        var noT = document.getElementById('bqQ2OptNoTitle');
        var noD = document.getElementById('bqQ2OptNoDesc');

        if (v === 'pregnant') {
          q2Title.textContent = 'Do you plan to pump after your baby arrives?';
          q2Hint.textContent = 'No wrong answer here — this just helps us plan ahead with you.';
          yesT.textContent = 'Yes — I plan to pump regularly';
          yesD.textContent = 'I want a bra ready to go for hands-free pumping';
          someT.textContent = 'Maybe, I\'m not sure yet';
          someD.textContent = 'I might pump sometimes but haven\'t decided';
          noT.textContent = 'No — I plan to nurse directly';
          noD.textContent = 'Just looking for easy nursing access';
        } else {
          q2Title.textContent = 'Do you use a breast pump?';
          q2Hint.textContent = 'This is the single biggest factor in which bra will work best for you.';
          yesT.textContent = 'Yes — I pump regularly';
          yesD.textContent = 'I need a bra that works with my pump so I don\'t have to change';
          someT.textContent = 'Sometimes, but not every day';
          someD.textContent = 'I pump occasionally but it\'s not my main thing';
          noT.textContent = 'No — I only nurse directly';
          noD.textContent = 'Just looking for easy nursing access';
        }
      }

      // Enable next button on the current screen
      var screen = opt.closest('.bq-screen');
      if (screen) {
        var nextBtn = screen.querySelector('.bq-btn--next');
        if (nextBtn) nextBtn.disabled = false;
      }
    });

    // ─── Navigation (next / back) ──────────────────────────────────────────────
    app.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-go]');
      if (!btn) return;
      if (btn.disabled) return;
      var dest = btn.dataset.go;
      if (dest === 'email') {
        showScreen('email');
      } else if (dest) {
        showScreen(dest);
      }
    });

    // ─── Email form ────────────────────────────────────────────────────────────
    if (emailForm) {
      emailForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailInput = document.getElementById('bqEmail');
        var email = emailInput ? emailInput.value.trim() : '';

        if (!isValidEmail(email)) {
          emailInput.classList.add('bq-input--error');
          emailInput.focus();
          return;
        }
        emailInput.classList.remove('bq-input--error');
        emailCaptured = true;

        submitToKlaviyo(email, function () {
          renderResult();
          showScreen('result');
          trackEvent('quiz_email_captured', { email: email });
        });
      });
    }

    if (skipBtn) {
      skipBtn.addEventListener('click', function () {
        trackEvent('quiz_email_skipped', {});
        renderResult();
        showScreen('result');
      });
    }

    // ─── Restart ───────────────────────────────────────────────────────────────
    if (restartBtn) {
      restartBtn.addEventListener('click', function () {
        answers = {};
        emailCaptured = false;

        // Clear all selections
        app.querySelectorAll('.bq-option').forEach(function (o) {
          o.classList.remove('selected');
          o.setAttribute('aria-checked', 'false');
        });
        app.querySelectorAll('.bq-btn--next').forEach(function (b) {
          b.disabled = true;
        });

        // Clear email field
        var emailInput = document.getElementById('bqEmail');
        if (emailInput) emailInput.value = '';

        trackEvent('quiz_restarted', {});
        showScreen('intro');
      });
    }

    // ─── Result rendering ──────────────────────────────────────────────────────
    function renderResult() {
      var rec = cfg.logic.recommend(answers);
      if (!rec) return;

      var primary   = cfg.products[rec.primary];
      var secondary = rec.secondary ? cfg.products[rec.secondary] : null;

      // Primary card
      var badge    = document.getElementById('bqResultBadge');
      var name     = document.getElementById('bqResultName');
      var tagline  = document.getElementById('bqResultTagline');
      var reasons  = document.getElementById('bqResultReasons');
      var shopLink = document.getElementById('bqShopPrimary');

      if (badge)    { badge.textContent = primary.badge; badge.className = 'bq-result-badge ' + primary.badgeClass; }
      if (name)     name.textContent = primary.name;
      if (tagline)  tagline.textContent = primary.tagline;
      if (shopLink) { shopLink.href = primary.url; shopLink.textContent = 'Shop ' + primary.name + ' — ' + primary.price; }

      if (reasons) {
        reasons.innerHTML = '';
        (rec.reasons || []).forEach(function (r) {
          var li = document.createElement('p');
          li.className = 'bq-reason';
          li.innerHTML = '<span class="bq-reason__check" aria-hidden="true">✓</span>' + escapeHtml(r);
          reasons.appendChild(li);
        });
      }

      // Secondary card
      var secCard    = document.getElementById('bqResultSecondary');
      var secName    = document.getElementById('bqSecondaryName');
      var secTagline = document.getElementById('bqSecondaryTagline');
      var secNote    = document.getElementById('bqSecondaryNote');
      var secLink    = document.getElementById('bqShopSecondary');

      if (secondary && secCard) {
        secCard.style.display = '';
        if (secName)    secName.textContent = secondary.name;
        if (secTagline) secTagline.textContent = secondary.tagline;
        if (secNote && rec.secondaryNote) secNote.textContent = rec.secondaryNote;
        if (secLink)    { secLink.href = secondary.url; secLink.textContent = 'Shop ' + secondary.name + ' — ' + secondary.price; }
      } else if (secCard) {
        secCard.style.display = 'none';
      }

      trackEvent('quiz_result_shown', {
        primary: rec.primary,
        secondary: rec.secondary || '',
        answers: JSON.stringify(answers)
      });
    }

    // ─── Klaviyo subscribe ─────────────────────────────────────────────────────
    function submitToKlaviyo(email, callback) {
      var kCfg = cfg.klaviyo;

      if (!kCfg.enabled || !kCfg.listId || kCfg.listId === 'REPLACE_WITH_YOUR_KLAVIYO_LIST_ID') {
        console.warn('[BraQuiz] Klaviyo not configured. Skipping subscribe.');
        callback();
        return;
      }

      // Build profile properties from quiz answers
      var profileProps = {
        '$email': email,
        'Quiz Source': kCfg.source,
        'Quiz Stage': answers.stage || '',
        'Quiz Pump': answers.pump || '',
        'Quiz Sleep': answers.sleep || '',
        'Quiz Lifestyle': answers.lifestyle || '',
        'Quiz Priority': answers.priority || '',
        'Quiz Access': answers.access || '',
        'Quiz Result': cfg.logic.recommend(answers).primary || ''
      };

      // Use Klaviyo JS API v2 (klaviyo.js already loaded by theme)
      if (typeof window._learnq !== 'undefined') {
        window._learnq.push(['identify', profileProps]);
        window._learnq.push(['track', 'Bra Quiz Completed', {
          primary_recommendation: profileProps['Quiz Result'],
          stage: answers.stage
        }]);
      }

      // Also POST to Klaviyo Subscribe API (adds to list)
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: profileProps
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: kCfg.listId
              }
            }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + getKlaviyoPublicKey(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
        body: JSON.stringify(payload)
      })
        .then(function () { callback(); })
        .catch(function (err) {
          console.warn('[BraQuiz] Klaviyo API error:', err);
          callback(); // still show results even if subscribe fails
        });
    }

    // Pull Klaviyo public API key from the already-loaded klaviyo.js
    function getKlaviyoPublicKey() {
      if (window.__kl_global && window.__kl_global.company_id) return window.__kl_global.company_id;
      // Fallback: scan meta tags
      var meta = document.querySelector('meta[name="klaviyo-public-api-key"]');
      return meta ? meta.content : '';
    }

    // ─── Analytics helper ──────────────────────────────────────────────────────
    function trackEvent(eventName, props) {
      // Shopify Web Pixels
      if (typeof analytics !== 'undefined' && analytics.publish) {
        try { analytics.publish(eventName, props); } catch (e) {}
      }
      // GTM dataLayer
      if (window.dataLayer) {
        window.dataLayer.push({ event: eventName, bq: props });
      }
      // Klaviyo track (non-blocking)
      if (typeof window._learnq !== 'undefined' && eventName === 'quiz_result_shown') {
        window._learnq.push(['track', 'Bra Quiz Completed', props]);
      }
    }

    // ─── Utilities ─────────────────────────────────────────────────────────────
    function isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function escapeHtml(str) {
      var d = document.createElement('div');
      d.appendChild(document.createTextNode(str));
      return d.innerHTML;
    }

  }); // DOMContentLoaded

})();
